import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-notifications-modal-item',
  templateUrl: './notifications-modal-item.component.html',
  styleUrls: ['./notifications-modal-item.component.scss']
})
export class NotificationsModalItemComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
